import { Link } from "react-router-dom";

interface BrincadeirasFooterLinkProps {
  className?: string;
}

/** Link do rodapé para a página pública de brincadeiras (para não ficar órfã). */
const BrincadeirasFooterLink = ({
  className = "text-[14px] text-text-muted hover:text-brand transition-colors",
}: BrincadeirasFooterLinkProps) => (
  <Link to="/brincadeiras-para-criancas" className={className}>
    Brincadeiras para crianças
  </Link>
);

export default BrincadeirasFooterLink;
